import { useState, useEffect } from 'react'
import axios from 'axios'
import { Pagination, Spin, Image, Tooltip } from 'antd'
import AddFitnessSeries from './add'
import EditFitnessSeries from './edit'
import DeleteFitnessSeries from './delete'
import FitnessSeriesRibbon from './ribbon'
import MyIcon from '../../components/general/icon'

export default function FitnessSeries() {
  const [fitnessSeriesData, setFitnessSeriesData] = useState({})
  const [propsData, setPropsData] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [isLoading, setIsLoading] = useState(true)
  const [isAddFitnessSeriesVisible, setIsAddFitnessSeriesVisible] = useState(false)
  const [isEditFitnessSeriesVisible, setIsEditFitnessSeriesVisible] = useState(false)
  const [isDeleteFitnessSeriesVisible, setIsDeleteFitnessSeriesVisible] = useState(false)

  const initialConditions = {
    keywords: '',
  }
  const [filterValue, setFilterValue] = useState(initialConditions)

  const getFitnessSeriesData = () => {
    axios.post('/admin/content/fitness_series/list/get', { 
      keywords: filterValue.keywords,
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setIsLoading(false)
          setFitnessSeriesData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'series': response.data.series
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getFitnessSeriesData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValue, currentPage])

  const editFitnessSeries = (oid) => {
    setIsEditFitnessSeriesVisible(true)
    setPropsData({ oid: oid })
  }

  const deleteFitnessSeries = (oid, title) => {
    setIsDeleteFitnessSeriesVisible(true)
    setPropsData({ oid: oid, title: title})
  }

  return (
    <div className="public-page">
      <Spin spinning={isLoading}>
        <div className="public-container">
          <div className="public-header">
            <div className="public-title">健身系列</div>
            <FitnessSeriesRibbon
              filterValue={filterValue} 
              setFilterValue={setFilterValue} 
              isAddVisible={() => { setIsAddFitnessSeriesVisible(true) }}  
            />
          </div>

          <div className='public-main-style'>
            <div className='public-main-style2'>
              <table className='public-main-style2-item'>
                <thead>
                  <tr className='public-main-style2-thead'>
                    <th style={{width: '300px'}}>
                      <div className='public-main-style2-title'>标题</div>
                    </th>
                    <th>内含视频数</th>
                    <th>排序</th>
                    <th style={{width: '50px'}}></th>
                  </tr>
                </thead>

                <tbody>
                  {fitnessSeriesData.series && (fitnessSeriesData.series.length > 0 ? (fitnessSeriesData.series.map((item) => (
                    <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { editFitnessSeries(item.oid) }}>
                      <td style={{width: '300px'}}>
                        <div className='public-main-style2-tuwen'>
                          <div style={{margin: '10px 15px 10px 0'}} onClick={(event) => {event.stopPropagation()}}>
                            <Image src={item.cover_url} width={100} height={80} />
                          </div>
                          <span>{item.title}</span>
                        </div>
                      </td>
                      <th>{item.video_numbers}</th>
                      <td>{item.sort}</td>
                      <td style={{width: '50px'}}>
                        <div className='public-main-style2-operation-box'>
                          <Tooltip placement="bottom" color='#1A1B1C' title="删除">
                            <div className='public-main-style2-operation' 
                              onClick={(event) => {event.stopPropagation(); deleteFitnessSeries(item.oid, item.title)}}>
                              <MyIcon name='huishouzhan' />
                            </div>
                          </Tooltip>
                        </div>
                      </td>
                    </tr>
                  ))) : (
                    <tr className='public-main-style2-tbodyEmpty'>
                      <td colSpan='4'><span>暂无数据</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className='pagination'>
              <Pagination 
                current={currentPage}
                total={fitnessSeriesData.total}
                pageSize={20}
                onChange={(page) => setCurrentPage(page)}
                showTotal={(total) => `共${total}条`}
                showSizeChanger={false}
                hideOnSinglePage={true}
                showQuickJumper={true}
              />
            </div>
          </div>
        </div>

        {isAddFitnessSeriesVisible && <AddFitnessSeries
          getFitnessSeriesData={getFitnessSeriesData} 
          isOpen={isAddFitnessSeriesVisible} 
          isCancel={() => { setIsAddFitnessSeriesVisible(false) }} 
        />}

        {isEditFitnessSeriesVisible && <EditFitnessSeries
          data={propsData}
          getFitnessSeriesData={getFitnessSeriesData} 
          isOpen={isEditFitnessSeriesVisible} 
          isCancel={() => { setIsEditFitnessSeriesVisible(false) }} 
        />}

        {isDeleteFitnessSeriesVisible && <DeleteFitnessSeries
          data={propsData}
          getFitnessSeriesData={getFitnessSeriesData} 
          isOpen={isDeleteFitnessSeriesVisible} 
          isCancel={() => { setIsDeleteFitnessSeriesVisible(false) }} 
        />}
      </Spin>
    </div>
  )
}
